import React, { useRef } from 'react';
import { cn } from 'lib/utils';

interface ColorSwatchProps {
  value?: string;
  onChange?: (hex: string) => void;
  className?: string;
  hasError?: boolean;
}

/** Figma color picker (3042:35629) — white chrome + 40px rounded color chip */
export const ColorSwatch: React.FC<ColorSwatchProps> = ({
  value = '#FFFFFF',
  onChange,
  className = '',
  hasError = false,
}) => {
  const colorInputRef = useRef<HTMLInputElement>(null);
  const safeValue = value?.startsWith('#') && value.length >= 4 ? value : '#FFFFFF';

  const handleColorPickerClick = () => {
    colorInputRef.current?.click();
  };

  const handleColorPickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value.toUpperCase());
  };

  return (
    <button
      type="button"
      onClick={handleColorPickerClick}
      className={cn(
        'relative flex shrink-0 cursor-pointer items-center rounded-[4px] border-[0.5px] border-solid border-[#b0b0b0] bg-white p-[6px]',
        hasError && 'border-destructive',
        className,
      )}
      title={safeValue}
      aria-label={`Color ${safeValue}`}
    >
      <span
        className="relative size-10 shrink-0 rounded-[4px]"
        style={{ backgroundColor: safeValue }}
      />
      <input
        ref={colorInputRef}
        type="color"
        value={safeValue}
        onChange={handleColorPickerChange}
        className="absolute inset-0 size-full cursor-pointer opacity-0"
        tabIndex={-1}
        aria-hidden
      />
    </button>
  );
};

export const validHexaColorReg =
  /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
